// Minimal stub for UserMusicDataService to maintain compatibility
// Recently played features removed from MVP - this provides empty implementations

export interface UserMusicProfile {
  recentlyPlayedArtists: Set<string>;
  libraryArtists: Set<string>;
  topGenres: string[];
  lastUpdated: Date;
}

export class UserMusicDataService {
  private static instance: UserMusicDataService;

  static getInstance(): UserMusicDataService {
    if (!UserMusicDataService.instance) {
      UserMusicDataService.instance = new UserMusicDataService();
    }
    return UserMusicDataService.instance;
  }

  async getUserMusicProfile(): Promise<UserMusicProfile> {
    return {
      recentlyPlayedArtists: new Set(),
      libraryArtists: new Set(),
      topGenres: [],
      lastUpdated: new Date()
    };
  }

  hasRecentlyPlayedData(): boolean {
    return false;
  }

  hasUserData(): boolean {
    return false;
  }

  calculateUserScoring(artist: any): { userRelevanceScore: number } {
    return { userRelevanceScore: 0 };
  }

  forceRefresh(): void {
    // No-op - recently played features removed
  }
}